import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { Link as ScrollLink } from "react-scroll"; // Importar correctamente
import { LanguageContext } from '../context/LanguageContext';

function WebHeaderLogin() {

   const { t } = useContext(LanguageContext); // 👈 Usa el hook para traer traducciones

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light">
      <div className="container-fluid">
        <Link className="navbar-brand" to="/">
        <img class= "logo1" src="https://storage.googleapis.com/tt202501/images/techtalamo_logo2.jpg"></img>
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        
        <div className="collapse navbar-collapse" id="navbarNav">
        
<ul className="navbar-nav">
            <li className="nav-item">
            <Link className="nav-link" to="/">{t('headReturn')}</Link>
            </li>
          </ul>
        
        </div>
      </div>
    </nav>
  );
}

export default WebHeaderLogin;